// Share only requests that are currently running, never settled results.
export function createInFlightRequests() {
  const pending = new Map();
  return {
    run(key, request) {
      if (!pending.has(key)) {
        const promise = Promise.resolve().then(request).finally(() => {
          if (pending.get(key) === promise) pending.delete(key);
        });
        pending.set(key, promise);
      }
      return pending.get(key);
    },
    clear() { pending.clear(); }
  };
}
